<!-- <h1>Manual {{ perfil }}</h1> -->
<h1>Manual do Sistema</h1>
<iframe
  referrerpolicy="same-origin"
  [src]="trustedUrl"
  width="100%"
  height="{{ iframeHeight }}"
  frameborder="0"
  cellspacing="0">
  <p>Your browser does not support iframes.</p>
</iframe>
